import { LANGS, LANG_LABELS, type Lang } from '@bingo/shared';
import { useAuth } from '../lib/auth';
import { useLang } from '../lib/i18n';

/** English / Français. Logged in: kept on the account; on the login page: kept on this device. */
export function LangSwitch() {
  const { lang, setLang, t } = useLang();
  const { me, setLanguage } = useAuth();
  const choose = (l: Lang) => (me ? void setLanguage(l) : setLang(l));
  return (
    <div className="seg" role="group" aria-label={t('Language')}>
      {LANGS.map((l) => (
        <button key={l} type="button" lang={l} aria-pressed={lang === l} onClick={() => choose(l)}>
          {LANG_LABELS[l]}
        </button>
      ))}
    </div>
  );
}
